var map = {
	"./Border1/index.vue": "c09e",
	"./Border1/setting.vue": "f135",
	"./Border10/index.vue": "0513d",
	"./Border10/setting.vue": "18c9",
	"./Border11/index.vue": "35d0",
	"./Border11/setting.vue": "e339",
	"./Border12/index.vue": "8ac1",
	"./Border12/setting.vue": "d955",
	"./Border13/index.vue": "5e92",
	"./Border13/setting.vue": "bebb",
	"./Border14/index.vue": "ffd68",
	"./Border14/setting.vue": "b023",
	"./Border15/index.vue": "39e8",
	"./Border15/setting.vue": "9c93",
	"./Border2/index.vue": "e46d",
	"./Border2/setting.vue": "02eb",
	"./Border3/index.vue": "cbcb",
	"./Border3/setting.vue": "b8f6",
	"./Border4/index.vue": "071f",
	"./Border4/setting.vue": "3b9b",
	"./Border5/index.vue": "da48",
	"./Border5/setting.vue": "7f19",
	"./Border6/index.vue": "b5fd",
	"./Border6/setting.vue": "96813",
	"./Border7/index.vue": "42c1",
	"./Border7/setting.vue": "84fc",
	"./Border8/BorderBox8.vue": "3899",
	"./Border8/index.vue": "f80f",
	"./Border8/setting.vue": "f108",
	"./Border9/index.vue": "b9df",
	"./Border9/setting.vue": "90f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "839d";